import React, { createContext, useContext, useState, useCallback } from 'react';

const AIProviderContext = createContext({ provider: 'openai', toggle: () => {} });

export function AIProviderProvider({ children }) {
  const [provider, setProvider] = useState(
    () => localStorage.getItem('aiProvider') || 'openai'
  );

  const toggle = useCallback(() => {
    setProvider(prev => {
      const next = prev === 'openai' ? 'claude' : 'openai';
      localStorage.setItem('aiProvider', next);
      return next;
    });
  }, []);

  return (
    <AIProviderContext.Provider value={{ provider, toggle }}>
      {children}
    </AIProviderContext.Provider>
  );
}

export const useAIProvider = () => useContext(AIProviderContext);
